import { SubmissionWithOperationDetailsPayload } from "@dune/types";
import { administrativeAuthorizationTypes } from "@dune/vars";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";

const zAdministrativeAuthorization = z.object({
	administrativeAuthorizationType: z
		.enum(administrativeAuthorizationTypes)
		.nullable(),
	authorizationReference: z.string(),
});

export type AdministrativeAuthorizationFormData = z.infer<
	typeof zAdministrativeAuthorization
>;

export type AdministrativeAuthorizationValues = Omit<
	SubmissionWithOperationDetailsPayload,
	"constructionSite"
>;

export const useAdministrativeAuthorizationForm = (
	initialValues?: AdministrativeAuthorizationValues,
) => {
	const form = useForm<AdministrativeAuthorizationFormData>({
		defaultValues: {
			administrativeAuthorizationType: null,
			authorizationReference: "",
		},
		resolver: zodResolver(zAdministrativeAuthorization),
	});
	const { reset, watch } = form;

	useEffect(() => {
		if (initialValues) {
			const administrativeAuthorizationType = watch(
				"administrativeAuthorizationType",
			);
			const initialAdministrativeAuthorizationType =
				initialValues.administrativeAuthorizationType ?? null;
			const authorizationReference = watch("authorizationReference");
			const initialAuthorizationReference =
				initialValues.authorizationReference || "";
			reset({
				administrativeAuthorizationType:
					administrativeAuthorizationType &&
					administrativeAuthorizationType !== "NO_NEED"
						? administrativeAuthorizationType
						: initialAdministrativeAuthorizationType,
				authorizationReference:
					authorizationReference || initialAuthorizationReference || "",
			});
		}
	}, [reset, initialValues, watch]);

	return { form };
};
